// stylelint-disable selector-no-vendor-prefix

uic-search-field {
  box-sizing: border-box;
  display: inline-block;
  padding: 8px;

  .uic-search-field__wrapper {
    position: relative;
  }

  .uic-search-field__input {
    background: var(--uic-color-blue6a20);
    border: 0;
    border-radius: 0;
    box-sizing: border-box;
    color: var(--uic-color-blue3);
    display: inline-block;
    font-size: 1rem;
    font-weight: bold;
    height: var(--uic-search-field-height);
    padding: 4px 44px 4px 8px;
    width: 100%;

    &::placeholder {
      color: var(--uic-color-grey3a50);
      font-weight: normal;
    }

    &::-ms-clear {
      display: none;
    }

    &:focus {
      outline: 2px solid var(--uic-color-blue2);
      outline-offset: -2px;
    }

    &:hover {
      color: var(--uic-color-blue3);
      outline: 1px solid var(--uic-color-blue2);
      outline-offset: -1px;
    }

    &:active {
      color: var(--uic-color-blue3);
      outline: 2px solid var(--uic-color-blue2);
      outline-offset: -2px;
    }

    &::-moz-selection,
    &::selection {
      background-color: var(--uic-color-blue2);
      color: var(--uic-color-white);
      padding: 2px;
    }
  }

  .uic-search-field__icon {
    color: var(--uic-color-grey3);
    display: block;
    height: var(--uic-icon-dimensions-default);
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    width: var(--uic-icon-dimensions-default);

    &--interactable {
      cursor: pointer;
    }
  }
}
